$(document).ready(function () {
  initStickyBasket();

  // Initialise des data target cliquables
  initURLTarget();

  // Initialisation des swiper
  initSwipers();

  // Initialisation des liens "voir tout" dans les mega-menus
  initMegaMenuViewAllLinks();

  // Initialisation des contrôles de son pour les vidéos
  initVideoSoundControls();

  // Gestion des accordeons FAQ
  $(".faq_question").on("click", function () {
    $(this).toggleClass("active");
    $(this).children(".faq_answer").slideToggle(200);
    $(this).find(".arrow").toggleClass("active");
    $(this)
      .find(".arrow")
      .text($(this).hasClass("active") ? "-" : "+");
  });

  // Footer mobile - menu accordeon
  if ($(window).width() < 768) {
    $(".footer_menu nav").on("click", function () {
      $(this).toggleClass("active");
      $(this).find("div").slideToggle(200);
    });
  }

  /***********************************************************************************/
  // Slider PDP
  function swiperMainProduct() {
    if (window.innerWidth <= 749) {
      var swiper = new Swiper(".media_list.swiper", {
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
      });
    }
  }

  swiperMainProduct();
  window.addEventListener("resize", swiperMainProduct);

  // dynamic height for product pictures slider
  if (window.innerWidth <= 749) {
    var headerHeight = $("header").innerHeight();
    var stickyBasketHeight = $("#sticky_basket").innerHeight();
    $(".product__media-wrapper").css("height", "calc(100vh - " + headerHeight + "px - " + stickyBasketHeight + "px)");
  }

  function initStickyBasket() {
    // Gestion du clic sur le bouton sticky
    $(".sticky_btn")
      .off("click.stickyBasket")
      .on("click.stickyBasket", function () {
        const productInfoWrapper = $(".product__info-wrapper");
        const wrapperOffsetTop = productInfoWrapper.offset().top;
        const wrapperHeight = productInfoWrapper.outerHeight();
        const viewportHeight = $(window).height();

        $([document.documentElement, document.body]).animate(
          {
            scrollTop: wrapperOffsetTop + wrapperHeight - viewportHeight - 80,
          },
          400
        );
      });
    // Variables globales pour le sticky basket
    const add_to_cart_buttons = $(".product-form__buttons");
    const sticky_basket = $("#sticky_basket");

    function checkStickyBasketVisibility() {
      if (add_to_cart_buttons.length === 0) {
        return;
      }

      const addToCartTop = add_to_cart_buttons.offset().top;
      const addToCartBottom = addToCartTop + add_to_cart_buttons.outerHeight();
      const scrollTop = $(window).scrollTop();
      const viewportHeight = $(window).height();

      // being sure to restrain this behavior to mobile devices
      if ($(window).width() < 1023) {
        // Si on a dépassé complètement les boutons d'ajout au panier, on cache le sticky basket
        if (scrollTop + viewportHeight > addToCartBottom) {
          sticky_basket.slideUp(150);
        } else {
          sticky_basket.slideDown(150);
        }
      }
    }

    // Vérifier la visibilité au chargement de la page
    checkStickyBasketVisibility();

    // Vérifier la visibilité au défilement
    $(document)
      .off("scroll.stickyBasket")
      .on("scroll.stickyBasket", function () {
        checkStickyBasketVisibility();
      });
  }

  // Initialisation du sticky basket
  initStickyBasket();

  // Rendre la fonction disponible globalement pour les autres scripts
  window.initStickyBasket = initStickyBasket;

  // Appearance of sticky_basket on scroll depending on whether the buy button is in the view
  // $(".sticky_btn").click(function () {
  //   const productInfoWrapper = $(".product__info-wrapper");
  //   const wrapperOffsetTop = productInfoWrapper.offset().top;
  //   const wrapperHeight = productInfoWrapper.outerHeight();
  //   const viewportHeight = $(window).height();

  //   $([document.documentElement, document.body]).animate(
  //     {
  //       scrollTop: wrapperOffsetTop + wrapperHeight - viewportHeight,
  //     },
  //     400
  //   );
  // });

  function isInViewport(el) {
    if (typeof el.get(0) === "undefined") {
      return false;
    }

    const rect = el.get(0).getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= ($(window).height() || $(document).height()) && rect.right <= ($(window).width() || $(document).width());
  }

  // On scroll
  // const add_to_cart_buttons = $(".product-form__buttons");
  // const sticky_basket = $("#sticky_basket");
  // const footer = $(".shopify-section-group-footer-group");

  // function checkStickyBasketVisibility() {
  //   if (add_to_cart_buttons.length === 0) {
  //     return;
  //   }

  //   const isAddToCartVisible = isInViewport(add_to_cart_buttons);
  //   const isFooterVisible = isInViewport(footer);

  //   // being sure to restrain this behavior to mobile devices
  //   if ($(window).width() < 1023) {
  //     // Si on a dépassé complètement les boutons d'ajout au panier, on cache le sticky basket
  //     if (scrollTop + viewportHeight > addToCartBottom) {
  //       sticky_basket.slideUp(150);
  //     } else {
  //       sticky_basket.slideDown(150);
  //     }
  //   }
  // }

  // // Vérifier la visibilité au chargement de la page
  // checkStickyBasketVisibility();

  // // Vérifier la visibilité au défilement
  // $(document).scroll(function () {
  //   checkStickyBasketVisibility();
  // });
});

// Mega menu hover - gestion améliorée pour éviter l'effet glitch
let isMenuOpen = false;
let closeTimeout;
const $menuWrapper = $(".mega-menu__content-wrapper");
const $menuItems = $(".header_main_menu .list-menu > li");
const $menu = $(".header_main_menu .list-menu");

function openMenu() {
  if (!isMenuOpen) {
    clearTimeout(closeTimeout);
    isMenuOpen = true;
    // Annuler l'événement transitionend qui pourrait être en attente
    $menuWrapper.off("transitionend");
    $menuWrapper.removeClass("menu-closing").addClass("menu-opening");
  }
}

function closeMenu() {
  if (isMenuOpen) {
    isMenuOpen = false;
    $menuWrapper.removeClass("menu-opening").addClass("menu-closing");

    // Écouter la fin de la transition au lieu d'utiliser setTimeout
    $menuWrapper.one("transitionend", function (e) {
      // S'assurer qu'on écoute bien la transition du bon élément
      if (e.target === this) {
        $(".mega-menu__content").removeClass("active");
        $menuWrapper.removeClass("menu-closing");
      }
    });
  }
}

$menuItems.each(function () {
  $(this).on("mouseenter", function () {
    const menuIndex = $(this).data("menu-index");

    clearTimeout(closeTimeout);

    // Trouver le contenu correspondant par data-menu-index
    const $currentContent = $(`.mega-menu__content[data-menu-index="${menuIndex}"]`);

    // Seulement ouvrir si il y a du contenu (liens avec sous-menus)
    if ($currentContent.length > 0) {
      openMenu();
      $(".mega-menu__content").removeClass("active");
      $currentContent.addClass("active");
    } else {
      closeMenu();
    }
  });
});

// Fermeture quand on quitte le menu principal
$(".header_main_menu").on("mouseleave", function () {
  closeTimeout = setTimeout(closeMenu, 150);
});

// Annuler la fermeture si on entre dans le mega menu
$menuWrapper.on("mouseenter", function () {
  clearTimeout(closeTimeout);

  // Si le menu est en cours de fermeture, le rouvrir
  if ($menuWrapper.hasClass("menu-closing")) {
    openMenu();
  }
});

// Fermeture quand on quitte le mega menu
$menuWrapper.on("mouseleave", function () {
  closeTimeout = setTimeout(closeMenu, 150);
});

// Clique sur la recherche dans le menu drawer
$(".header_drawer_search").on("click", function () {
  $(".header_second_menu .header__search > details").attr("open", true);
});

// Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
function initURLTarget() {
  $("[data-url_target]").click(function () {
    var url = $(this).data("url_target");
    if (url && url !== "#") {
      window.location.href = url;
    }
  });
}

// Initialisation des Swipers de carte produit
function initSwipers() {
  document.querySelectorAll(".product_item_wrap.swiper").forEach((swiperEl, index) => {
    let swiper = new Swiper(swiperEl, {
      direction: "horizontal",
      loop: true,
      speed: 300,
      effect: "fade", // Par défaut "slide" sur mobile
      fadeEffect: {
        crossFade: true,
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      navigation: {
        enabled: false,
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
      breakpoints: {
        769: {
          navigation: {
            enabled: true,
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
      },
    });

    // Ajout de l'effet hover sur la carte produit
    if (window.innerWidth > 749) {
      let productCard = swiperEl.closest(".product_item"); // S'assurer qu'on cible bien la carte produit
      if (productCard) {
        productCard.addEventListener("mouseenter", () => {
          swiper.slideTo(1); // Passe à la deuxième image
        });

        productCard.addEventListener("mouseleave", () => {
          swiper.slideTo(0); // Retourne à la première image
        });
      }
    }

    $(swiperEl)
      .find(".swiper-button-next, .swiper-button-prev")
      .click(function (e) {
        e.stopPropagation(); // Empêche la propagation de l'événement de clic
      });
  });

  // Slider images collection
  document.querySelectorAll(".collection-hero-images.swiper").forEach((swiperEl, index) => {
    let swiper = new Swiper(swiperEl, {
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 4,
      freeMode: true,
    });
  });
}

// Initialisation des liens "voir tout" dans les mega-menus
function initMegaMenuViewAllLinks() {
  const megaMenuLinks = document.querySelectorAll(".mega-menu__link");

  megaMenuLinks.forEach((link) => {
    const linkText = link.textContent.toLowerCase().trim();

    if (linkText.includes("voir tout") || linkText.includes("tout voir") || linkText.includes("see all") || linkText.includes("all our")) {
      link.classList.add("mega-menu__link--view-all");
    }
  });
}

// Gestion des contrôles de son pour les vidéos
function initVideoSoundControls() {
  document.querySelectorAll(".sound-controls__button").forEach((button) => {
    button.addEventListener("click", function (e) {
      e.stopPropagation();
      const videoSection = this.closest(".video-section-wrapper");
      const videos = videoSection.querySelectorAll("video");

      videos.forEach((video) => {
        if (video.muted) {
          video.muted = false;
          this.classList.add("sound-on");
        } else {
          video.muted = true;
          this.classList.remove("sound-on");
        }
      });
    });
  });
}
